import { Outlet, createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { LoadingPage } from "@/components/layout";
import { useAuthStore } from "@/stores/auth.store";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent
});

function RouteComponent() {
  const { loggedIn, loading } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !loggedIn) {
      navigate({ to: "/" });
    }
  }, [loading, loggedIn, navigate]);

  if (loading) {
    return <LoadingPage />;
  }

  return <Outlet />;
}
